/**
 * Release-safe breadcrumbs of this tab's leader-proxy opens (web): worker creation, every election
 * status transition (including a `failed` leader's reason) and the open's outcome.
 *
 * Release web builds log only to Sentry, so a signed-in open that never settles — the page stuck on
 * "Syncing data from cloud..." with the sync handle never published — leaves no trace anywhere. The
 * web nav layout publishes this trail through an invisible accessibility node, which a Maestro
 * hierarchy dump captures.
 */

const MAX_EVENTS = 16;

const traceState: { events: string[]; listeners: Set<() => void>; snapshot: string } = {
  events: [],
  listeners: new Set(),
  snapshot: "",
};

export function recordLeaderOpenTrace(resourceId: string, event: string): void {
  traceState.events.push(`${Math.round(performance.now())}ms ${resourceId} ${event}`);
  if (traceState.events.length > MAX_EVENTS) {
    traceState.events.shift();
  }
  traceState.snapshot = traceState.events.join(" | ");
  for (const listener of traceState.listeners) {
    listener();
  }
}

export function getLeaderOpenTrace(): string {
  return traceState.snapshot;
}

export function subscribeLeaderOpenTrace(listener: () => void): () => void {
  traceState.listeners.add(listener);
  return () => {
    traceState.listeners.delete(listener);
  };
}
